import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

const mongoDbAtlasContent = EntityContentBlueprint.make({
  name: 'mongodb-atlas',
  params: {
    path: '/mongodb',
    title: 'MongoDB',
    group: 'operation',
    filter: entity =>
      entity.kind.toLocaleLowerCase('en-US') === 'component' &&
      Boolean(entity.metadata.annotations?.['mongodb.com/atlas-project-id']) &&
      Boolean(entity.metadata.annotations?.['mongodb.com/atlas-cluster']),
    loader: () =>
      import('./MongoDbAtlasContent').then(m => <m.MongoDbAtlasContent />),
  },
});

export const mongoDbAtlasModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [mongoDbAtlasContent],
});
